module.exports = __webpack_public_path__ + "static/media/lock.99a9032c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/lock.svg
// module id = 18
// module chunks = 0